import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { productAPI } from '../api/services';
import { useAuth } from './AuthContext';

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchWishlist = useCallback(async () => {
    if (!user) { setWishlist([]); return; }
    try {
      const res = await productAPI.getWishlist();
      setWishlist(res.data.wishlist || []);
    } catch { setWishlist([]); }
  }, [user]);

  useEffect(() => { fetchWishlist(); }, [fetchWishlist]);

  const toggle = async (productId) => {
    if (!user) return false;
    try {
      const res = await productAPI.toggleWishlist(productId);
      if (res.data.inWishlist) {
        setWishlist(prev => [...prev, { _id: productId }]);
      } else {
        setWishlist(prev => prev.filter(p => (p._id || p) !== productId));
      }
      return res.data.inWishlist;
    } catch { return false; }
  };

  const isInWishlist = (productId) =>
    wishlist.some(p => (p._id || p)?.toString() === productId?.toString());

  return (
    <WishlistContext.Provider value={{ wishlist, loading, toggle, isInWishlist, fetchWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error('useWishlist must be used within WishlistProvider');
  return ctx;
};
